/**
 * useViewMode Hook
 *
 * Manages grid/list view mode preference with localStorage persistence.
 */

import { useState, useEffect, useCallback } from 'react';
import type { ViewMode } from '../components/ViewToggle';

const STORAGE_KEY = 'nfa_view_mode';

export function useViewMode(defaultMode: ViewMode = 'grid') {
  const [mode, setMode] = useState<ViewMode>(() => {
    if (typeof window === 'undefined') return defaultMode;
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'list' || stored === 'grid' ? stored : defaultMode;
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, mode);
  }, [mode]);

  const setViewMode = useCallback((newMode: ViewMode) => {
    setMode(newMode);
  }, []);

  return { mode, setViewMode };
}
